export const settings = {
  tooltipDelay: 1000
}

export const localisation = {
  defaultLocale: 'en',
  validLocals: ['en', 'de']
}

export const routing = {
  routes: {
    'root': 'http://legaltech.local',
    'reset_password': '/password/reset',
    'register': '/register'
  }
}

export const canvas = {
  colors: {
    quadrant: ['#673AB7', '#2196F3', '#00BCD4', '#009688'],
    sector: ['#81D4FA', '#B3E5FC', '#E1F5FE', 'none']
  }
}
